<template>
  <div
    class="zoox-component zoox-action-card-tab-template"
    :class="{scrolless}"
  >
    <h3 class="template-title">{{ title }}</h3>
    <div class="template-actions">
      <!--@slot Slot onde as ações do componentes são colocadas -->
      <slot name="actions" />
    </div>

    <z-tabs-card :android="android" class="template-content" :tabs="tabs">
      <template v-for="(tab, index) in tabs" v-slot:[tab.id]>
        <component
          :is="contentWrapperComponent"
          :key="index"
          class="scrolless-content"
          :class="{scrolless}"
        >
          <slot :name="tab.id"></slot>
        </component>
      </template>
    </z-tabs-card>
  </div>
</template>

<script>
/**
 * Componente de template de página usando abas para separar o conteúdo, que é utilizado para construir a estrutura
 * da página. Normalmente vai ser o "esqueleto" de uma página completa, sendo necessário adicionar somente
 * o conteúdo através da utilização dos slots. Esse template ja segue um padrão de
 * @displayName Tabs Card Template
 */
export default {
  name: 'ZTabsCardTemplate',
  props: {
    /**
     * Array de objetos que indicam as tabs
     *
     * @typedef Object {id:string,text:string,disabled:boolean,icon:string}
     *
     * */
    tabs: {
      type: Array,
      required: true,
    },
    /**
     * Define o titulo do template
     */
    title: {
      type: String,
    },
    /**
     * Aplica o estilo android às tabs do componente
     */
    android: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     *  Prop para indicar que o conteúdo principal não deve gerar scroll vertical
     */
    scrolless: {type: Boolean, required: false, default: false},
  },
  computed: {
    contentWrapperComponent() {
      return this.scrolless ? 'z-scrollbar' : 'div'
    },
  },
}
</script>

<style lang="scss" scoped>
.zoox-action-card-tab-template {
  display: grid;
  grid-template-areas:
    'title actions'
    'content content';
  grid-template-columns: auto 1fr;
  grid-template-rows: auto 1fr;
  row-gap: 12px;
  min-height: calc(100vh - 48px);
  padding: 15px;

  &.scrolless {
    height: calc(100vh - 35px);
    max-height: calc(100vh - 35px);
  }

  .v-tabs {
    border-radius: var(--component-card-radius);
  }
  .zoox-tab {
    border-radius: 5px;
  }
}

.template-actions {
  justify-self: flex-end;
  grid-area: actions;
  display: flex;

  > * {
    margin-left: 5px;
    margin-right: 5px;
  }
}

.template-content {
  grid-area: content;
}

.template-title {
  grid-area: title;
}

.scrolless-content {
  height: 100%;

  &.scrolless {
    overflow-y: auto;
    max-height: calc(100vh - 150px);
  }
}
</style>
